import SimpleModel from './SimpleModel';

class Driver extends SimpleModel {
  props() {
    return {
      checkInExpiration: null,
      firstName: null,
      key: null,
      lastName: null,
      fullName: '',
    };
  }
}

export default Driver;
